import api from '../utils/api';

const curriculumService = {
  topics: params => api.get('/api/curriculum/topics', { params }),
  createTopic: data => api.post('/api/curriculum/topics', data),
  updateTopic: (id, data) => api.patch(`/api/curriculum/topics/${id}`, data),
  updateCoverage: (id, data) => api.patch(`/api/curriculum/topics/${id}/coverage`, data),
  lessonPlans: params => api.get('/api/curriculum/lesson-plans', { params }),
  createLessonPlan: data => api.post('/api/curriculum/lesson-plans', data),
  updateLessonPlan: (id, data) => api.patch(`/api/curriculum/lesson-plans/${id}`, data),
  coverage: params => api.get('/api/curriculum/coverage', { params }),
  coverageSummary: () => api.get('/api/curriculum/coverage/summary'),
  lessonNotes: params => api.get('/api/curriculum/lesson-notes', { params }),
  createLessonNote: data => api.post('/api/curriculum/lesson-notes', data),
  updateLessonNote: (id, data) => api.patch(`/api/curriculum/lesson-notes/${id}`, data),
  teacherActivity: params => api.get('/api/curriculum/teacher-activity', { params }),

  // ---- Curriculum standards catalog + topic linking ----
  standards: params => api.get('/api/curriculum/standards', { params }),
  createStandard: data => api.post('/api/curriculum/standards', data),
  updateStandard: (id, data) => api.put(`/api/curriculum/standards/${id}`, data),
  deleteStandard: id => api.delete(`/api/curriculum/standards/${id}`),
  topicStandards: topicId => api.get(`/api/curriculum/topics/${topicId}/standards`),
  linkTopicToStandard: (topicId, standardIds) => api.post(`/api/curriculum/topics/${topicId}/standards`, { standard_ids: standardIds }),
  unlinkTopicFromStandard: (topicId, standardId) => api.delete(`/api/curriculum/topics/${topicId}/standards/${standardId}`),
};

export default curriculumService;